module.exports = __webpack_public_path__ + "img/web_5.ce8914ac.png";